import * as ACTIONS from "../actions/types"
import * as _ from "lodash"

// A reducer to hold the main data for the survey
// This might not be actually needed...

const defaultState = {
  options: null,
  byID: {},
  allIDs: []
}

const reducer = (state = defaultState, { type, payload }) => {
  switch (type) {
    case ACTIONS.FETCH_PLANS_SUCCESS: {
      const {
        options,
        plansByID,
        defaultPlanByDevice,
        planOrderByDevice,
        buildAPlanByStores
      } = payload

      return {
        ...state,
        options,
        defaultPlanByDevice,
        planOrderByDevice,
        buildAPlanByStores,
        byID: plansByID,
        allIDs: Object.keys(plansByID)
      }
    }

    case ACTIONS.FETCH_PICKED_PLANS_SUCCESS: {
      const conditionOptions = {}
      const conditionDefaultPlanByDevice = {}
      const conditionPlanOrderByDevice = {}
      const conditionByID = {}
      const conditionAllIDs = {}

      Object.keys(payload).forEach(conditionID => {
        const {
          options,
          plansByID,
          defaultPlanByDevice,
          planOrderByDevice
        } = payload[conditionID]

        conditionOptions[conditionID] = options
        conditionDefaultPlanByDevice[conditionID] = defaultPlanByDevice
        conditionPlanOrderByDevice[conditionID] = planOrderByDevice
        conditionByID[conditionID] = plansByID
        conditionAllIDs[conditionID] = Object.keys(plansByID)
      })

      return {
        ...state,
        options: conditionOptions,
        defaultPlanByDevice: conditionDefaultPlanByDevice,
        planOrderByDevice: conditionPlanOrderByDevice,
        byID: conditionByID,
        allIDs: conditionAllIDs
      }
    }

    case ACTIONS.REPLACE_PLANS: {
      const { plans, planBuilder } = payload

      // remove any missing plans from planOrderByDevice
      const newPlanOrderByDevice = _.cloneDeep(state.planOrderByDevice)
      Object.keys(newPlanOrderByDevice).forEach(deviceID => {
        newPlanOrderByDevice[deviceID] = newPlanOrderByDevice[
          deviceID
        ].filter(planID => Object.prototype.hasOwnProperty.call(plans, planID))
      })

      return {
        ...state,
        planOrderByDevice: newPlanOrderByDevice,
        byID: plans,
        allIDs: Object.keys(plans),
        buildAPlanByStores: planBuilder
      }
    }

    default:
      return state
  }
}

export default reducer
